var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18001 12C5.65334 11.3667 5.33334 10.5533 5.33334 9.66667C5.33334 7.65333 6.98001 6 9.00001 6H12.3333C14.3467 6 16 7.65333 16 9.66667C16 11.68 14.3533 13.3333 12.3333 13.3333H10.6667",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 12.0013C18.3467 12.6346 18.6667 13.448 18.6667 14.3346C18.6667 16.348 17.02 18.0013 15 18.0013H11.6667C9.65333 18.0013 8 16.348 8 14.3346C8 12.3213 9.64667 10.668 11.6667 10.668H13.3333",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0409f060610ca7e92674f972b222395d.svg";
export { ForwardRef as ReactComponent };